define('app/nav/MasterTabView',['require','glu/itemView','glu/dialog','./NavBar','app/config/strings','app/config/reportTypes','app/app','glu/$','hbs!./MasterTabView.hbs'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView'),
		dialog = require('glu/dialog'),
		NavBar = require('./NavBar'),
		strings = require('app/config/strings'),
		reportTypes = require('app/config/reportTypes'),
		APP = require('app/app'),
		$ = require('glu/$');


	var openReports = APP.openReports;

	return ItemView.extend({

		initialize: function() {
			this.collection = openReports;
			this.dialog = dialog;
			this.listenTo(this.collection, 'add remove change', this.render);
			this.listenTo(this.appBus, 'nav:render', this.render);
			this.listenTo(this.appBus, 'nav:dashboard', this.selectDashboard);
			this.listenTo(this.appBus, 'nav:report', this.selectReport);
			this.listenTo(this.appBus, 'nav:monitor', this.selectReport);
		},

		events: {
			'click .btn-close': 'onCloseTab'
		},

		serializeData: function() {
			return this;
		},

		template: require('hbs!./MasterTabView.hbs'),

		selectedReportCid: null,

		newReportId: 0,

		isDashboardSelected: function() {
			return this.selectedReportCid === null;
		},

		reports: function() {
			var self = this;

			return this.collection.map(function(r) {
				var href, tabCss;

				if (r.getModelName() === strings.reportModelName) {
					if (r.id) {
						href = ['', 'domains', r.getDomainId(), 'reports', r.id].join('/');
					} else {
						href = ['', 'domains', r.getDomainId(), 'unsaved-report', r.cid].join('/');
					}

					if (r.getReportType() === reportTypes.METRIC) {
						tabCss = 'icon-key';
					} else if (r.getReportType() === reportTypes.SEGMENT) {
						tabCss = 'icon-donut-graph';
						href = ['', 'domains', r.getDomainId(), 'segments', r.id].join('/');
					} else if (r.getReportType() === reportTypes.ALERT) {
						tabCss = 'icon-clock';
					} else {
						// get report visualization
						var visualization = r.getVisualization();
						switch (visualization) {
							case 'donut-chart':
								tabCss = 'icon-kpi';
								break;
							case 'line-chart':
								tabCss = 'icon-line-graph';
								break;
							case 'bar-chart':
								tabCss = 'icon-bar-graph';
								break;
							case 'pie-chart':
								tabCss = 'icon-pie-graph';
								break;
							case 'stacked-bar-chart':
								tabCss = 'icon-funnel-graph';
								break;
							case 'scatter-plot':
								tabCss = 'icon-scatter-graph';
								break;
							case 'pivot-table':
								tabCss = 'icon-pivot-table';
								break;
							case 'segment':
								tabCss = 'icon-donut-graph';
								break;
							default:
								tabCss = 'icon-table';
						}

					}

				} else if (r.getModelName() === strings.monitorModelName) {
					if (r.id) {
						href = ['', 'domains', r.getDomainId(), 'monitors', r.id].join('/');
					} else {
						href = ['', 'domains', r.getDomainId(), 'unsaved-monitor', r.cid].join('/');
					}
					tabCss = 'icon-workspace';
				}

				return {
					cid: r.cid,
					name: r.getName(),
					href: href,
					tabCss: tabCss,
					isSelected: r.cid === self.selectedReportCid || r.id !== undefined && r.id === self.selectedReportId
				};
			});
		},

		selectReport: function(report) {
			this.selectedReportCid = report.cid;
			this.selectedReportId = report.id;
			if (!this.collection.get(report)) {
				this.collection.add(report);
			}
			this.render();
		},

		selectDashboard: function() {
			this.selectedReportCid = null;
			this.selectedReportId = null;

			this.render();
		},

		addReport: function(report) {
			this.selectedReportCid = report.cid;
			this.collection.add(report);
		},

		getReportById: function(cid) {
			return this.collection.get(cid);
		},

		onCloseTab: function(evt) {
			var cid = evt.target.getAttribute('data-cid');
			var self = this;

			if (self.collection.get(cid).isDirty()) {
				var dialogMessage;
				if (self.collection.get(cid).getModelName() === strings.monitorModelName) {
					dialogMessage = strings.closeUnsavedMonitorWarning;
				} else {
					dialogMessage = strings.closeUnsavedReportWarning;
				}

				this.dialog.confirm(dialogMessage, strings.areYouSure,
					function(ok) {
						if (ok) {
							if (cid === self.selectedReportCid) {
								self.render();
								self.navigateTo('/dashboard');
								var counter = 0;
								var checkExist = setInterval(function() {
									if ($('.page-dashboard').length) {
										self.collection.remove(cid);
										self.selectedReportCid = null;
										clearInterval(checkExist);
									}
									if (counter > 20) {
										self.navigateTo('/dashboard'); // try to redirect again
									}
									counter++;
								}, 100); // check every 100ms
							} else {
								self.collection.remove(cid);
							}
						}
					});

			} else {
				if (cid === self.selectedReportCid) {
					self.render();
					self.navigateTo('/dashboard');
					var counter = 0;
					var checkExist = setInterval(function() {
						if ($('.page-dashboard').length) {
							self.collection.remove(cid);
							self.selectedReportCid = null;
							clearInterval(checkExist);
						}
						if (counter > 20) {
							self.navigateTo('/dashboard'); // try to redirect again
						}
						counter++;
					}, 100); // check every 100ms
				} else {
					self.collection.remove(cid);
				}
			}
		},

		onRender: function() {
			this.generateNavBar();
		},

		generateNavBar: function() {
			var view = new NavBar({
				model: this.model
			});

			view.render();

			this.$el.find('.navbar').append(view.render().el);
		}
	});
});

